<donut-alert :theme="theme" :message="message" button-text="Upgrade to Premium" :button-is-primary="true" @clickedButton="showPaywall"></donut-alert>